import React from 'react'
import DonutChart from 'components/visualization/Donut'
import {
  MetricItemContainer,
  Legend,
  LegendProps,
  MetricItemContainerProps
} from '../share/components'
import { ChartValue, inValidNumberToZero } from '../share/utils'
import { ExplanationData } from '../../types'

interface DonutData {
  name: string
  y: ChartValue
  isBreak?: boolean
  chartBreakTooltipContent?: string
  explanation?: ExplanationData
}

type CenterValue = number
type DeltaValue = string

interface CenterSection {
  title?: string
  value?: CenterValue
  valueFormatter?: (value: CenterValue) => string
  deltaValue?: DeltaValue
  deltaValueFormatter?: (value: DeltaValue) => string
  deltaDirection?: 'up' | 'down' | 'none'
}

export interface DonutMetricItemProps {
  data: DonutData[]
  chartOptions: {
    centerSection: CenterSection
    colorSettings: Record<string, string>
  }
  legendOptions: Partial<LegendProps> & { isShowLegend: boolean }
  disabledInfo?: MetricItemContainerProps['disabledInfo']
  explanation: MetricItemContainerProps['explanation']
}

const DonutMetricItem = ({
  data,
  chartOptions,
  legendOptions,
  disabledInfo = {
    isDisabled: false
  },
  explanation
}: DonutMetricItemProps) => (
  <MetricItemContainer disabledInfo={disabledInfo} explanation={explanation}>
    <DonutChart
      data={data.map((d) => ({ ...d, y: inValidNumberToZero(d.y) }))}
      showDataLabel={false}
      trackThickness={17}
      size="234px"
      centerSection={{
        type: 'summary',
        ...chartOptions.centerSection
      }}
      colorSettings={chartOptions.colorSettings}
    />
    {legendOptions?.isShowLegend && (
      <Legend
        data={legendOptions?.data || data}
        colorSettings={legendOptions?.colorSettings || chartOptions.colorSettings}
        isDisplayPercent
      />
    )}
  </MetricItemContainer>
)

export default DonutMetricItem
